import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";

const FullstackVideoCard_1 = () => {
  return (
    <div className="card w-50 h-auto">
      <div className="card-body bg-dark text-white">
        <h5 className="card-title">MTTR and MTBF App tracker</h5>
        <p className="card-text">
          I build this application for one of my lines where I managed the maintenance department.
          The porposue of this app was to track the MTTR and MTBF of the machines.
        </p>

        <h6>
          Investment: <span>$5,000 USD</span>
        </h6>
        <h6>
          Time to build: <span>4 months</span>
        </h6>
        <h6>
          Technology: <span>Program was made on Android Studio and Data base was develop using Postgres.
          Data Base was hosted on AWS.
          </span>
        </h6>
      </div>
    </div>
  );
};

export default FullstackVideoCard_1;
